import { yesNoOptions, numbersOnlyPattern } from '../_constants';

const dollarAmountValidationMessages = {
  required: 'Please provide us your home loan repayments. If not applicable, please enter 0.',
  minLength: 'Must have at least {{minLength}} digits.',
  maxLength: 'Must have at most {{maxLength}} digits.',
  invalid: 'Please enter a whole dollar amount, without cents.',
};

const validationMessages = {
  dollarAmount: dollarAmountValidationMessages,
};

export const additionalDebtsDetails = [
  {
    component: 'RadioTile',
    name: 'hasOtherDebts',
    label: 'Do you have any loans, credit cards or overdrafts?',
    testId: 'has-other-debts',
    options: yesNoOptions,
    showCircles: true,
    validate: {
      messages: {
        required: 'Please select yes or no.',
      },
    },
  },
  {
    condition: values => values.hasOtherDebts === 'yes',
    name: 'hasOtherDebtsYes',
    fields: [
      {
        component: 'Frequency',
        name: 'secondaryPropertyMortgageRentBoard',
        label: 'Additional mortgage or rent',
        testId: 'secondary-mortgage-rent-board',
        helpText: 'Your share of investment property loans or rent NOT including your primary living property expense.',
        mode: 'select',
        amountPrefix: '$',
        annually: false,
        validate: {
          props: { maxLength: 8, validPattern: numbersOnlyPattern },
          messages: validationMessages.dollarAmount,
          component: 'Frequency',
        },
      },
      {
        component: 'Frequency',
        name: 'loanRepayment',
        label: 'Other loan repayments',
        helpText: 'Your share of personal loans or motor loans.',
        testId: 'loan-repayment',
        mode: 'select',
        annually: false,
        quarterly: false,
        amountPrefix: '$',
        validate: {
          props: { validPattern: numbersOnlyPattern },
          messages: validationMessages.dollarAmount,
          component: 'Frequency',
        },
      },
      {
        component: 'Input',
        label: 'Total limits on credit cards, overdrafts, finance and charge cards',
        name: 'totalCardLimits',
        testId: 'total-card-limits',
        variant: 'numeric',
        prefix: '$',
        validate: {
          props: {
            minLength: 1,
            maxLength: 6,
            validPattern: numbersOnlyPattern,
          },
          messages: validationMessages.dollarAmount,
        },
      },
    ],
  },
];
